import round from './round';
import breakCountdown from './break';
import { getRandomItems } from './../utils/array';
import { toExercise } from './../utils/mapping';

const legLifts = [
        {
          name: 'Hold legs out',
          description: 'Hold your legs six inches from the ground and tighten your core'
        }, {
          name: 'windshield wipers'
        }, {
          name: 'leg raises'
        }, {
          name: 'windshield wipers with leg raises',
          description: 'Windshield wipers, but pause halfway to lift your legs up and lower them back down'
        }, {
          name: 'paddlers',
          description: 'hold your feet out and paddle your feet up and down'
        }, {
          name: 'Paddle lifts',
          description: 'hold your feet out and paddle your feet up and down, while slowly lifting your legs up and down'
        }, {
          name: 'criss crosses',
          description: 'hold legs out and cross one ankle over the other'
        }, {
          name: 'clockwise lifts',
          description: 'Hold legs out, and move them up and around in a clockwise direction'
        }, {
          name: 'counter-clockwise lifts',
          description: 'Hold legs out, and move them up and around in a counter-clockwise direction'
        }
      ].map(toExercise);

const crunches = [
        {
          name: 'crunches'
        }, {
          name: 'held crunches',
          description: 'Crunch up and hold it for three seconds'
        }, {
          name: 'slow crunches',
          description: 'Crunch up and down so each takes about five seconds'
        }, {
          name: 'Cross crunches (right)',
          description: 'Put your left leg up and your right arm behind your body, and crunch your right side to your left knee'
        }, {
          name: 'Cross crunches (left)',
          description: 'Put your right leg up and your left arm behind your body, and crunch your left side to your right knee'
        }, {
          name: 'russian twists'
        }, {
          name: 'crunches with hands behind head'
        }, {
          name: 'chest cross crunches',
          description: 'Crunches with your hands crossed over your chest'
        }, {
          name: 'jab cross crunches',
          description: 'Do a jab cross at the top of the crunch'
        }, {
          name: 'double jab cross crunches',
          description: 'Do two jab crosses at the top of the crunch'
        }, {
          name: 'raised, crossed crunches',
          description: 'crunches while raising your legs and crossing your ankles'
        }, {
          name: 'ankle touches'
        }, {
          name: 'knee touches'
        }, {
          name: 'leg reaches',
          description: 'Legs straight up, reaching up and down to your toes'
        }, {
          name: 'bicycle kicks'
        }
      ].map(toExercise);

const finishingExercises = [
        {
          name: 'high plank'
        }, {
          name: 'low plank'
        }
      ].map(toExercise);

const exercises = [
        ...getRandomItems(legLifts, 8),
        ...getRandomItems(crunches, 10),
        ...getRandomItems(finishingExercises, 2)
      ].reverse();

const shortExercises = [
        ...getRandomItems(legLifts, 7),
        ...getRandomItems(crunches, 6),
        ...getRandomItems(finishingExercises, 1)
      ].reverse();

const coreBaseCountdown = (setState, finishedCallback) => {
  return round(
    15, // minutes
    45, // timeUnit
    'Core',
    exercises,
    setState,
    finishedCallback
  )
};

const shortCoreBaseCountdown = (setState, finishedCallback) => {
  return round(
    7, // minutes
    30, // timeUnit
    'Core',
    shortExercises,
    setState,
    finishedCallback
  )
};

const coreCountdown = (setState, finishedCallback) => {
  return [
    breakCountdown('Core', setState, finishedCallback),
    coreBaseCountdown(setState, finishedCallback)
  ]
}

const shortCoreCountdown = (setState, finishedCallback) => {
  return [
    breakCountdown('Core', setState, finishedCallback),
    shortCoreBaseCountdown(setState, finishedCallback)
  ]
}

export { coreCountdown, shortCoreCountdown };
